import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Privacy = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Privacyverklaring"
        description="Privacyverklaring KS Care. Hoe wij omgaan met persoonsgegevens, bewaartermijnen en uw rechten conform de AVG."
        keywords="privacy, privacyverklaring, AVG, persoonsgegevens, rechten"
        
      />
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h1 
              className="text-4xl md:text-5xl font-bold text-[#1A4D4D] mb-6"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Privacyverklaring
            </h1>
            <p className="text-gray-600">Laatst bijgewerkt: december 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            
            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">1. Wie zijn wij?</h2>
              <p className="text-gray-600 leading-relaxed">
                KS Care is een zorgaanbieder voor dagbesteding en logeeropvang voor jeugd met ASS, ADHD en gedragsproblematiek. 
                Wij zijn gevestigd aan Delweide 34, 6118 AH Nieuwstadt. KVK-nummer: 85306452.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">2. Welke gegevens verzamelen wij?</h2>
              <p className="text-gray-600 leading-relaxed mb-4">Wij verzamelen de volgende persoonsgegevens:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Naam, adres en contactgegevens van ouders/verzorgers</li>
                <li>Naam, geboortedatum en gegevens van het kind</li>
                <li>Medische informatie relevant voor de zorgverlening</li>
                <li>BSN-nummer (indien nodig voor financiering)</li>
                <li>Foto's en video's (alleen met toestemming)</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">3. Waarvoor gebruiken wij deze gegevens?</h2>
              <p className="text-gray-600 leading-relaxed mb-4">Wij gebruiken uw gegevens voor:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Het verlenen van goede en veilige zorg aan uw kind</li>
                <li>Communicatie met ouders/verzorgers</li>
                <li>Administratie en facturering</li>
                <li>Voldoen aan wettelijke verplichtingen</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">4. Hoe lang bewaren wij uw gegevens?</h2>
              <p className="text-gray-600 leading-relaxed">
                Wij bewaren persoonsgegevens niet langer dan noodzakelijk. Medische dossiers worden conform de wet 20 jaar bewaard na beëindiging van de zorg. Overige gegevens worden 2 jaar na beëindiging van de zorgrelatie verwijderd.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">5. Delen wij uw gegevens?</h2>
              <p className="text-gray-600 leading-relaxed">
                Wij delen uw gegevens alleen met derden indien dit noodzakelijk is voor de zorgverlening (bijv. huisarts, specialist) of wanneer wij hiertoe wettelijk verplicht zijn. Wij vragen altijd eerst uw toestemming, tenzij dit wettelijk niet vereist is.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">6. Uw rechten</h2>
              <p className="text-gray-600 leading-relaxed mb-4">U heeft het recht om:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Uw gegevens in te zien</li>
                <li>Uw gegevens te laten corrigeren</li>
                <li>Uw gegevens te laten verwijderen</li>
                <li>Bezwaar te maken tegen verwerking</li>
                <li>Uw gegevens over te dragen</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">7. Beveiliging</h2>
              <p className="text-gray-600 leading-relaxed">
                Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen verlies, misbruik of onbevoegde toegang.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">8. Contact</h2>
              <p className="text-gray-600 leading-relaxed">
                Heeft u vragen over deze privacyverklaring of wilt u gebruik maken van uw rechten? Neem dan contact met ons op:
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-xl">
                <p className="text-gray-700"><strong>KS Care</strong></p>
                <p className="text-gray-600">Delweide 34</p>
                <p className="text-gray-600">6118 AH Nieuwstadt</p>
                <p className="text-gray-600">Tel: 06-19199023</p>
                <p className="text-gray-600">Email: info@kscare.nl</p>
              </div>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">9. Klachten</h2>
              <p className="text-gray-600 leading-relaxed">
                Indien u een klacht heeft over de verwerking van uw persoonsgegevens, kunt u contact met ons opnemen. U heeft ook het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;
